"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var onErrorResumeNext_1 = require("../../operator/onErrorResumeNext");
rxjs_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs-compat/add/operator/onErrorResumeNext.js
// module id = 1200
// module chunks = 0